import { render } from "./SinglePortfolioItem.vue?vue&type=template&id=1ff9fcee"
import script from "./SinglePortfolioItem.vue?vue&type=script&lang=js"
export * from "./SinglePortfolioItem.vue?vue&type=script&lang=js"

import "./SinglePortfolioItem.vue?vue&type=style&index=0&id=1ff9fcee&lang=scss"

import exportComponent from "/var/www/prod.storm.ms/actions-runner/storm-site/storm-site/storm-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__